export default "__VITE_ASSET__g7ytX0tJ__"